import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(({ spacing }) => ({
  headerWrapper: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-end",
    marginRight: spacing(6),
  },
  title: {
    background: "transparent",
    padding: 0,
    margin: spacing(0, 0, 2, 0),
    lineHeight: 1.5,
  },
}));

export default useStyles;
